import axios from 'axios';
import { ISellerCollection, ISellerListParams } from 'entities/Seller/Seller.models';

const basePath = 'seller';

export const sellerTransport = {
  get: (params: ISellerListParams): Promise<ISellerCollection> => axios.get(`${basePath}`, { params }),
};
